module.exports = __webpack_public_path__ + "img/IMG-20200311-WA0032.3f97987c.jpg";